import React from 'react'
import About from './About'
import Contact from './Contact'
import Hero from './Hero'
import Naavbar from './Navbar'
import Projects from './Projects'
import Skills from './Skills'

class Container extends React.Component{
    render(){
        return(
            <>
                <div className='Container'>
                    <Naavbar/>
                    <Hero/>
                    <About/>
                    <Skills/>
                    <Projects/>
                    <Contact/>
                </div>
            </>
        )
    }
}

export default Container